/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PhoneNumberBody,
    PhoneNumberBodyFromJSON,
    PhoneNumberBodyFromJSONTyped,
    PhoneNumberBodyToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateUserBody
 */
export interface CreateUserBody {
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    password?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    confirmPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    email: string;
    /**
     * 
     * @type {PhoneNumberBody}
     * @memberof CreateUserBody
     */
    phoneNumber?: PhoneNumberBody;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    referralCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserBody
     */
    onboardingSignedUrlKey?: string;
}

export function CreateUserBodyFromJSON(json: any): CreateUserBody {
    return CreateUserBodyFromJSONTyped(json, false);
}

export function CreateUserBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUserBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': !exists(json, 'password') ? undefined : json['password'],
        'confirmPassword': !exists(json, 'confirmPassword') ? undefined : json['confirmPassword'],
        'email': json['email'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : PhoneNumberBodyFromJSON(json['phoneNumber']),
        'firstName': !exists(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !exists(json, 'lastName') ? undefined : json['lastName'],
        'referralCode': !exists(json, 'referralCode') ? undefined : json['referralCode'],
        'onboardingSignedUrlKey': !exists(json, 'onboardingSignedUrlKey') ? undefined : json['onboardingSignedUrlKey'],
    };
}

export function CreateUserBodyToJSON(value?: CreateUserBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
        'confirmPassword': value.confirmPassword,
        'email': value.email,
        'phoneNumber': PhoneNumberBodyToJSON(value.phoneNumber),
        'firstName': value.firstName,
        'lastName': value.lastName,
        'referralCode': value.referralCode,
        'onboardingSignedUrlKey': value.onboardingSignedUrlKey,
    };
}


